import constants from 'constants/index'

const isActivityInReview = (activity) =>
  !!activity?.coveredByReview &&
  (!!activity?.openReview ||
    activity?.status ===
      constants.governanceProjectActivity.AWAITING_APPROVAL_STATUS_ID)

export default isActivityInReview
